import { render, staticRenderFns } from "./TaggedPoliciesListModal.vue?vue&type=template&id=2dcbf51e&"
import script from "./TaggedPoliciesListModal.vue?vue&type=script&lang=js&"
export * from "./TaggedPoliciesListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcbf51e')) {
      api.createRecord('2dcbf51e', component.options)
    } else {
      api.reload('2dcbf51e', component.options)
    }
    module.hot.accept("./TaggedPoliciesListModal.vue?vue&type=template&id=2dcbf51e&", function () {
      api.rerender('2dcbf51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/TaggedPoliciesListModal.vue"
export default component.exports